<script lang="ts">
export default {
  name: 'AccountTowerVisualizer',
};
</script>

<script setup lang="ts">
import UILayer from '@/views/account/tower/UILayer.vue';
import TowerCanvas from '@/views/account/tower/TowerCanvas.vue';
import { ref, provide, onBeforeMount, onMounted, onBeforeUnmount } from 'vue';
import { ProgramTower } from '@/types/tower/v2/Tower';
import { getElementHeight, getElementWidth } from '@/utilities/DOM';
import { TowerCardData } from '@/views/tower_dashboard/types/tower-dashboard';

const props = defineProps<{
  serializedTower: string;
}>();

const emit = defineEmits<{
  goBack: [];
}>();

// -----
// refs
// -----

const pageRef = ref<HTMLElement>();
const width = ref<number>(pageRef.value?.clientWidth ?? 0);
const height = ref<number>(pageRef.value?.clientHeight ?? 0);
const resizeObserver = ref<ResizeObserver>({} as ResizeObserver);
const tower = ref<ProgramTower>();

// ---------
// provider
// ---------

const canvas = ref<fabric.Canvas>();
const selectedTower = ref<TowerCardData>();
provide('towerInfo', {
  canvas,
  selectedTower,
});

// ----------------
// lifecycle hooks
// ----------------

onBeforeMount(() => {
  tower.value = { towerObject: JSON.parse(props.serializedTower) } as ProgramTower;
});

onMounted(() => {
  // handle resizing of the page
  resizeObserver.value = new ResizeObserver(() => {
    if (pageRef.value) {
      width.value = getElementWidth(pageRef.value);
      height.value = getElementHeight(pageRef.value);
    }
  });
  resizeObserver.value.observe(pageRef.value as Element);
});

onBeforeUnmount(() => {
  resizeObserver.value.disconnect();
});
</script>

<template>
  <div ref="pageRef" class="absolute w-full h-full">
    <UILayer @go-back="emit('goBack')"/>
    <TowerCanvas v-if="tower" :width="width" :height="height" :tower="tower" />
  </div>
</template>
